<template>
	<page>
		<div class="home-page">
			<!-- 到期提醒：剩余使用时间少于30天时显示 -->
			<div v-if="expireDays !== null && expireDays < 30" class="expire-bar flex-between-center">
				<div class="flex-center-cross">
					<i class="tf">&#xe621;</i>
					<p>系统剩余使用时间不足<span>{{Math.max(expireDays, 0)}}天</span>；逾期未续费系统将无法正常使用</p>
				</div>
				<a class="expire-btn">续费</a>
			</div>

			<div class="home-main flex">
				<div class="home-left flex-grow">
					<!-- 待办统计 -->
					<div class="card todo-card-box">
						<div class="todo-card">
							<ul class="todo-list flex" :style="{'left': -todoPageIndex * 100 + '%', 'min-width': todoList.length / 6 * 100 + '%'}">
								<li v-for="(item, i) in todoList" :key="i" class="todo-item flex-column flex-center" :class="`z-${item.type}`" :style="{'width': 1 / todoList.length * 100 * 0.9 + '%', 'margin-right': 1 / todoList.length * 100 * 0.1 + '%'}" @click="todoHandle(item)">
									<p class="todo-value" :style="{'color': item.value == 0 ? '#bbb' : ''}">{{item.value}}</p>
									<p class="todo-label">{{item.label}}</p>
								</li>
							</ul>
							<div class="todo-nav" @click="todoPageIndex++"><div :style="{'left': todoPageIndex / todoPageSize * 100 + '%', 'width': 1 / todoPageSize * 100 + '%'}"></div></div>
						</div>
					</div>

					<!-- 实时概况 -->
					<div class="card card-overview">
						<div class="card-head flex-between-center">
							<h3>实时概况</h3>
							<p class="card-extra">更新于：{{overview.updateTime}}</p>
						</div>
						<div class="overview-body flex-wrap">
							<div v-for="(item, i) in overview.list" :key="i" class="ov-item flex-between-center">
								<div>
									<p class="ov-label">{{item.label}}</p>
									<p class="ov-value">{{item.value}}</p>
								</div>
								<div class="ov-yesterday">
									<p class="ov-label">昨日</p>
									<p class="ov-compare">
										<template v-if="item.compare.dir == 'flat'">
											<span class="z-flat">{{item.compare.text}}</span>
										</template>
										<template v-else>
											<span :class="`z-${item.compare.dir}`">{{item.compare.dir == 'up' ? '↗' : '↘'}} {{item.compare.rate}}</span>
										</template>
										<em>{{item.compare.value}}</em>
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- 我的看板 -->
					<div class="card">
						<div class="card-head flex-between-center">
							<h3>我的看板</h3>
							<a class="board-more flex-center-cross" @click="$refs.boardMetricConfig.open()"><i class="tf">&#xe643;</i>更多指标</a>
						</div>
						<div class="board-body flex flex-wrap">
							<div v-for="(item, i) in boardList" :key="i" class="board-item flex-column flex-center-main">
								<p class="board-label">{{item.label}}</p>
								<p class="board-value">{{item.value}}</p>
							</div>
						</div>
					</div>

					<!-- 趋势图表 -->
					<div class="card card-chart">
						<div class="card-head chart-head flex-between-center">
							<div class="chart-tab flex">
								<span v-for="item in chartTabList" :key="item.key" :class="{'z-alive': chartTab == item.key}" @click="switchChartTab(item.key)">{{item.name}}</span>
							</div>
							<div class="range-group flex">
								<a v-for="item in rangeList" :key="item.value" :class="{'z-alive': chartRange == item.value}" @click="switchRange(item.value)">{{item.label}}</a>
							</div>
						</div>
						<div class="chart-body">
							<div ref="chart" class="chart"></div>
						</div>
					</div>
				</div>

				<!-- 右侧栏 -->
				<div class="home-aside flex-column flex-shrink">
					<!-- 公司信息 -->
					<div class="card company">
						<div class="flex-center-cross">
							<div class="company-logo flex-center">
								<img src="@/assets/image/icon.png" alt="">
							</div>
							<div class="flex-grow">
								<div class="flex-start-center">
									<p class="company-name">{{companyName}}</p>
									<span class="company-vip">{{accountInfo.version_name || '-'}}</span>
								</div>
								<div class="company-line flex-center-cross">
									<p>ID: {{accountInfo.user_id || '-'}}</p>
									<span class="company-role">{{accountInfo.is_manage == 1 ? '主账号' : '子账号'}}</span>
									<p class="company-code">商户代码：{{accountInfo.saas_id || '-'}}<i class="tf" @click="copySaasId">&#xe6b0;</i></p>
								</div>
							</div>
						</div>
						<div class="company-account flex-between-center">
							<p>渠道同售积分：<a @click="navigateTo('/finance/points/account')">{{accountInfo.channel_points || 0}}分</a></p>
							<p>IMEI查询积分：<a @click="navigateTo('/finance/imei/points/account')">{{accountInfo.imei_points || 0}}分</a></p>
							<p>到期时间：{{accountInfo.auth_exp_date || '-'}}</p>
						</div>
					</div>

					<!-- 常用功能 -->
					<div class="card">
						<div class="card-head flex-between-center">
							<h3>常用功能</h3>
							<i class="aside-config tf tf-config" @click="openFrequentConfig"></i>
						</div>
						<div class="func-body flex flex-wrap">
							<a v-for="(item, i) in funcList" :key="i" class="func-item flex-center" @click="openFunc(item)">{{item.name}}</a>
							<p v-if="!funcList.length" class="func-empty">请点击右上角配置常用功能</p>
						</div>
					</div>

					<!-- 最新公告 -->
					<div class="card flex-grow flex-column">
						<div class="card-head flex-between-center">
							<h3>最新公告</h3>
							<a class="aside-more flex-center-cross" @click="openNotice">更多<i class="tf tf-angle-right"></i></a>
						</div>
						<c-scroll class="flex-grow">
							<ul class="notice-body">
								<li v-for="(item, i) in noticeList" :key="i" :class="{'article-read': item.isRead}" @click="openArticle(1, item.id)">
									<div class="flex-center-cross">
										<span class="notice-tag">{{item.tag}}</span>
										<p class="notice-title flex-grow">{{item.title}}</p>
										<span v-if="item.isNew" class="notice-new">NEW</span>
									</div>
									<p class="notice-time">{{item.time}}</p>
								</li>
							</ul>
						</c-scroll>
					</div>

					<!-- 新手入门 -->
					<div class="card card-guide flex-column">
						<div class="card-head flex-between-center">
							<h3>新手入门</h3>
							<a class="aside-more flex-center-cross" @click="openGuide">更多<i class="tf tf-angle-right"></i></a>
						</div>
						<c-scroll class="flex-grow">
							<ul class="guide-body">
								<li v-for="(item, i) in guideList" :key="i" class="flex-center-cross" :class="{'article-read': item.isRead}" @click="openArticle(2, item.id)">
									<i class="tf tf-doc"></i>
									<p>{{item.title}}</p>
								</li>
							</ul>
						</c-scroll>
					</div>
				</div>
			</div>
		</div>
		<board-metric-config ref="boardMetricConfig" @resolve="loadBoardConfig"></board-metric-config>
		<frequent-route-config ref="frequentRouteConfig" @resolve="loadFrequentRoute"></frequent-route-config>
	</page>
</template>

<script>
	import * as echarts from 'echarts'
	import {mapState, mapGetters} from 'vuex'
	import BoardMetricConfig from '@/components/home/board_metric_config.vue'
	import FrequentRouteConfig from '@/components/home/frequent_route_config.vue'

	export default {
		name: 'home',
		components: {BoardMetricConfig, FrequentRouteConfig},

		data() {
			return {
				// 待办统计：接驳类待办对门店版不摆，见 buildTodoList
				todoList: this.buildTodoList(null, this.$store.getters.hasHandover),
				todoPageIndex: 0,

				// 实时概况
				overview: {
					updateTime: '2026-06-23 19:48:33',
					list: [
						{label: '销售量', value: '', compare: {dir: '', rate: '', value: ''}},
						{label: '销售金额', value: '', compare: {dir: '', text: '', value: ''}},
						{label: '销售订单数', value: '', compare: {dir: '', rate: '', value: ''}},
						{label: '动销率', value: '', compare: {dir: '', rate: '', value: ''}},
						{label: '回收数量', value: '', compare: {dir: '', rate: '', value: ''}}
					]
				},

				// 我的看板
				boardList: [
					{label: '应收总额', value: ''},
					{label: '应付总额', value: ''},
					{label: '总库存', value: ''},
					{label: '已入库', value: ''},
					{label: '调拨中', value: ''},
					{label: '累计线下采购', value: ''},
					{label: '累计线上采购', value: ''},
					{label: '累计采购金额', value: ''}
				],
				boardMetricMap: {},
				boardMetricConfig: [],

				// 根据用户路由访问记录和固定配置动态生成
				funcList: [],

				// 最新公告
				noticeList: [],

				// 新手入门
				guideList: [],

				chartTab: 'sales',
				chartTabList: [
					{key: 'sales', name: '销售趋势'},
					{key: 'stock', name: '库存分析'}
				],
				chartRange: 7,
				accountInfo: {},
				chartData: {
					dates: [],
					firstSeries: [],
					secondSeries: [],
					firstSeriesName: '',
					secondSeriesName: ''
				},
				rangeList: [
					{label: '近7天', value: 7},
					{label: '近30天', value: 30},
					{label: '近90天', value: 90}
				]
			}
		},

		computed: {
			...mapState(['saasInfo', 'navList', 'authList']),
			...mapGetters(['hasHandover']),

			todoPageSize() {
				return Math.ceil(this.todoList.length / 6);
			},

			companyName() {
				return this.accountInfo.saas_name || (this.saasInfo && this.saasInfo.saas_name) || '-';
			},

			// 距到期剩余天数，无到期时间时返回 null
			expireDays() {
				if (!this.accountInfo.auth_exp_date) return null;
				const exp = new Date(String(this.accountInfo.auth_exp_date).replace(/-/g, '/'));
				if (isNaN(exp.getTime())) return null;
				return Math.ceil((exp.getTime() - Date.now()) / 86400000);
			}
		},

		watch: {
			todoPageIndex: {
				handler(val) {
					if (val >= this.todoPageSize) {
						this.todoPageIndex = 0;
					} else {
						clearTimeout(this._todoTimer);
						this._todoTimer = setTimeout(() => {
							this.todoPageIndex++;
						}, 5000);
					}
				},
				immediate: true
			}
		},

		mounted() {
			this.$nextTick(() => {
				try {
					this.chartObj = echarts.init(this.$refs.chart);
					this.loadTrend();
					this.chartObj.resize();
				} catch(e) {
					console.error('首页图表初始化失败', e);
				}
			});
			this.loadSummary();
			this.loadBoardConfig();
			this.loadFrequentRoute();
			this.loadAccount();
			this.loadArticles();
			window.addEventListener('resize', this.resize);
		},

		beforeDestroy() {
			window.removeEventListener('resize', this.resize);
			this.chartObj && this.chartObj.dispose();
			clearTimeout(this._todoTimer);
		},

		methods: {
			/**
			 * 工作台待办项：门店版没有接驳环节，也没有质检/维修列表（那几个列表以生效接驳为准入条件），
			 * 带接驳语义的待办对它恒为0、点进去还是无权限页面，所以整项不摆；
			 * 有没有接驳由服务端登录信息下发（见 store getter hasHandover），端内不拿版本编码判等
			 */
			buildTodoList(todo, has_handover) {
				const list = [
					{label: '质检接驳', key: 'quality_handover', handoverOnly: true, path: '/quality/quality_handover', workType: 4, viewId: 500102},
					{label: '维修接驳', key: 'repair_handover', handoverOnly: true, path: '/repair/repair_handover', workType: 5, viewId: 600102},
					{label: '销售接驳', key: 'sales_handover', handoverOnly: true, path: '/product/sales_handover', workType: 6, viewId: 20040102},
					{label: '待发货(线上)', key: 'pending_online_delivery', path: '/sales/online_order_list', workType: 12, viewId: 20010102},
					{label: '待质检', key: 'pending_quality', handoverOnly: true, path: '/quality/quality_list', workType: 7, viewId: 500202},
					{label: '待维修', key: 'pending_repair', handoverOnly: true, path: '/repair/repair_list', workType: 15, viewId: 600202},
					{label: '超卖订单', key: 'pending_oversold', type: 'red', path: '/product/oversold_list', workType: 14, viewId: 200301},
					{label: '下架异常', key: 'pending_delist_abnormal', type: 'red', path: '/product/abnormal_list', workType: 11, viewId: 20040302}
				];
				const result = [];
				list.forEach(item => {
					if (item.handoverOnly && has_handover === false) return;
					result.push({
						label: item.label,
						// 数据未回来时先摆占位符，与改造前的静态默认值表现一致
						value: todo ? (todo[item.key] || 0) : '-',
						type: item.type,
						path: todo ? item.path : undefined,
						workType: todo ? item.workType : undefined,
						viewId: todo ? item.viewId : undefined
					});
				});
				return result;
			},

			resize() {
				this.chartObj && this.chartObj.resize();
			},

			switchChartTab(tab) {
				this.chartTab = tab;
				this.loadTrend();
			},

			switchRange(days) {
				this.chartRange = days;
				this.loadTrend();
			},

			loadSummary() {
				this.request({
					url: '/workbench/summary',
					data: {},
					success: data => {
						this.todoList = this.buildTodoList(data.todo || {}, this.hasHandover);
						const overview = data.overview || {};
						this.overview = {
							updateTime: data.updated_at || '-',
							list: [
								this.buildOverviewItem('销售量', overview.sales_quantity),
								this.buildOverviewItem('销售金额', overview.sales_amount, false, true),
								this.buildOverviewItem('销售订单数', overview.sales_order_count),
								this.buildOverviewItem('动销率', overview.sell_through_rate, true),
								this.buildOverviewItem('回收数量', overview.recycle_quantity)
							]
						};
						this.boardMetricMap = data.board || {};
						this.updateBoardList();
					}
				});
			},

			loadBoardConfig() {
				this.request({
					url: '/workbench/board/config',
					data: {},
					success: data => {
						this.boardMetricConfig = data.selected_list || [];
						this.updateBoardList();
					}
				});
			},

			loadFrequentRoute() {
				this.request({
					url: '/workbench/frequent',
					data: {},
					success: data => {
						const options = this.getFrequentRouteOptions();
						const routeMap = options.reduce((map, item) => {
							map[item.route] = item;
							return map;
						}, {});
						const displayList = (data.display_list || []).map(item => routeMap[item.route_name]).filter(Boolean);
						// 后台未配置常用功能时，默认取前八个
						this.funcList = displayList.length ? displayList : options.slice(0, 8);
					}
				});
			},

			getFrequentRouteOptions() {
				const authMap = this.authList.reduce((map, item) => {
					map[item.key] = true;
					return map;
				}, {});
				const options = [];
				const collect = menuList => {
					(menuList || []).forEach(menu => {
						if (menu.menu_unique_key && /^m_[A-Za-z0-9_]{1,61}$/.test(menu.menu_unique_key) && authMap[menu.menu_unique_key] && this.auth(menu.menu_unique_key)) {
							options.push({name: menu.menu_name, route: menu.menu_unique_key});
						}
						collect(menu.child_menu_list);
					});
				};
				collect(this.navList);
				return options.filter((item, index) => options.findIndex(option => option.route === item.route) === index);
			},

			openFrequentConfig() {
				this.$refs.frequentRouteConfig.open(this.getFrequentRouteOptions());
			},

			updateBoardList() {
				if (!this.boardMetricConfig.length) return;
				this.boardList = this.boardMetricConfig.map(item => ({
					label: item.name,
					value: this.formatNumber(this.boardMetricMap[item.code]),
					highlight: item.highlight === 'true'
				}));
			},

			loadAccount() {
				this.request({
					url: '/workbench/account',
					data: {},
					success: data => {
						this.accountInfo = data || {};
					}
				});
			},

			loadTrend() {
				this.request({
					url: '/workbench/trend',
					data: {metric_type: this.chartTab, days: this.chartRange},
					success: data => {
						this.chartData = {
							dates: data.dates || [],
							firstSeries: data.first_series || [],
							secondSeries: data.second_series || [],
							firstSeriesName: data.first_series_name || '',
							secondSeriesName: data.second_series_name || ''
						};
						this.updateChart();
					}
				});
			},

			loadArticles() {
				this.request({
					url: '/article/published/list',
					data: {article_type: 1, order_by_id_desc: true, pageIndex: 1, pageSize: 5},
					success: data => {
						this.noticeList = (data || []).map(item => ({
							id: item.id,
							tag: item.consultation_name || '公告',
							type: 'product',
							title: item.title,
							time: item.create_date || '',
							isNew: Number(item.is_new) === 1,
							isRead: Number(item.is_read) === 1
						}));
					}
				});
				this.request({
					url: '/article/published/list',
					data: {article_type: 2, order_by_id_desc: true, pageIndex: 1, pageSize: 5},
					success: data => {
						this.guideList = (data || []).map(item => ({
							id: item.id,
							title: item.title,
							isRead: Number(item.is_read) === 1
						}));
					}
				});
			},

			buildOverviewItem(label, source, percent, fixed) {
				source = source || {};
				return {
					label,
					value: this.formatNumber(source.current, percent, fixed),
					compare: {
						dir: source.direction || 'flat',
						rate: source.rate === null || source.rate === undefined ? '--' : source.rate + '%',
						text: '持平',
						value: this.formatNumber(source.previous, percent, fixed)
					}
				};
			},

			formatNumber(value, percent, fixed) {
				const number = Number(value || 0);
				if (percent) return (number * 100).toFixed(1) + '%';
				if (fixed) return number.toFixed(2);
				return Number.isInteger(number) ? String(number) : number.toFixed(2);
			},

			updateChart() {
				if (!this.chartObj) return;
				const {dates, firstSeries, secondSeries, firstSeriesName, secondSeriesName} = this.chartData;
				const areaColor = rgba => new echarts.graphic.LinearGradient(0, 0, 0, 1, [
					{offset: 0, color: rgba[0]},
					{offset: 1, color: rgba[1]}
				]);
				this.chartObj.setOption({
					color: ['#3D5EFF', '#FF5555'],
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						left: 16,
						right: 16,
						top: 30,
						bottom: 44,
						containLabel: true
					},
					legend: {
						bottom: 0,
						icon: 'rect',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#666',
							fontSize: 12
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: dates,
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#E5E6EB'
							}
						},
						axisLabel: {
							color: '#999'
						}
					},
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: {
								color: '#F2F3F5'
							}
						},
						axisLabel: {
							color: '#999'
						}
					},
					series: [{
						name: firstSeriesName,
						type: 'line',
						smooth: true,
						symbol: 'none',
						lineStyle: {
							width: 2
						},
						areaStyle: {
							color: areaColor(['rgba(61,94,255,.18)', 'rgba(61,94,255,0)'])
						},
						data: firstSeries
					}, {
						name: secondSeriesName,
						type: 'line',
						smooth: true,
						symbol: 'none',
						lineStyle: {
							width: 2
						},
						areaStyle: {
							color: areaColor(['rgba(255,85,85,.12)', 'rgba(255,85,85,0)'])
						},
						data: secondSeries
					}]
				}, true);
			},

			// 复制商户代码
			copySaasId() {
				if (!this.accountInfo.saas_id) return;
				const textarea = document.createElement('textarea');
				textarea.value = this.accountInfo.saas_id;
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('copy');
				document.body.removeChild(textarea);
				this.$message({
					message: '商户代码已复制到剪贴板',
					type: 'success'
				});
			},

			openFunc(item) {
				item.route && this.navigateTo({name: item.route});
			},

			openNotice() {
				this.navigateTo('/article/1');
			},

			openGuide() {
				this.navigateTo('/article/2');
			},

			openArticle(type, id) {
				this.navigateTo(`/article/${type}/detail/${id}`);
			},

			todoHandle(item) {
				let config = JSON.parse(localStorage.getItem(item.workType) || '{}')
				localStorage.setItem(item.workType, JSON.stringify({
					v: item.viewId,
					g: '',
					s: config.s || ''
				}));
				this.navigateTo(item.path);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.home-page {
		box-sizing: border-box;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		padding: 15px;
		background-image: url('~@/assets/image/home_bg.jpg');
		background-size: cover;

		.card {
			border-radius: 8px;
			background: rgba(255,255,255,.8);

			&-head {
				height: 50px;
				padding: 0 20px;

				h3 {
					font-size: 16px;
					font-weight: bold;
					color: #333;
				}

				.card-extra {
					font-size: 12px;
					color: #999;
				}
			}
		}

		/* 到期提醒 */
		.expire-bar {
			flex-shrink: 0;
			height: 46px;
			border-radius: 8px;
			padding: 0 16px;
			margin-bottom: 12px;
			background: linear-gradient(90deg, #FFF1F0, #FFF6F0);

			.tf {
				margin-right: 8px;
				font-size: 16px;
				color: #FF4D4F;
			}

			p {
				font-size: 13px;
				color: #666;

				span {
					font-weight: bold;
					color: #FF4D4F;
				}
			}

			&-btn {
				flex-shrink: 0;
				border-radius: 15px;
				padding: 0 22px;
				line-height: 30px;
				font-size: 13px;
				color: #fff;
				background: #FF4D4F;
				transition: all .2s ease;

				&:hover {
					background: #FF3333;
				}
			}
		}

		/* 待办统计 */
		.todo-card {
			position: relative;
			overflow: hidden;

			&-box {
				box-sizing: border-box;
				height: 142px;
				padding: 12px 90px 0 50px;
				background-image: url('~@/assets/image/home_todo.png');
				background-position: right bottom;
				background-repeat: no-repeat;
				background-size: auto 150px;
			}

			.todo-nav {
				position: absolute;
				left: 50%;
				bottom: 0;
				width: 50px;
				height: 4px;
				border-radius: 2px;
				margin-left: -25px;
				background: #ddd;
				cursor: pointer;

				div {
					position: absolute;
					left: 0;
					top: 0;
					width: 50%;
					height: 100%;
					border-radius: 2px;
					background: var(--color-main);
					transition: left .3s ease;
				}
			}

			.todo-list {
				position: relative;
				transition: left .3s ease;
			}

			.todo-item {
				height: 90px;
				margin: 15px 0;
				cursor: pointer;

				.todo-value {
					font-size: 30px;
					font-weight: bold;
					color: var(--color-main);
					transition: all .2s ease;
				}

				&.z-red .todo-value {
					color: #FF4D4F;
				}

				&:hover .todo-label {
					color: var(--color-main);
				}

				.todo-label {
					margin-top: 20px;
					font-size: 14px;
					color: #666;
				}
			}

		}

		.home-main {
			gap: 12px;
			flex-grow: 1;
			flex-shrink: 0;

			.card + .card {
				margin-top: 12px;
			}
		}

		.home-left {
			display: flex;
			flex-direction: column;
		}

		/* 实时概况 */
		.card-overview {
			flex-grow: 1;
			display: flex;
			flex-direction: column;
		}

		.overview-body {
			gap: 24px;
			padding: 0 20px 20px;

			.ov-item {
				position: relative;
				box-sizing: border-box;
				width: calc((100% - 48px) / 3)
				height: 90px;
				padding: 0 20px;

				&:after {
					content: '';
					position: absolute;
					right: 0;
					top: 50%;
					width: 1px;
					height: 60px;
					margin-top: -30px;
					background: #E5E5E5;
				}

				&:nth-child(3n):after {
					display: none;
				}

				.ov-label {
					font-size: 13px;
					color: #999;
				}

				.ov-value {
					margin-top: 10px;
					font-size: 26px;
					font-weight: bold;
					color: #333;
				}

				.ov-yesterday {
					text-align: right;

					.ov-compare {
						margin-top: 16px;
						font-size: 12px;
						color: #999;

						.z-up {
							color: #FF4D4F;
						}

						.z-down {
							color: #07B461;
						}

						.z-flat {
							color: #999;
						}

						em {
							margin-left: 8px;
							font-style: normal;
						}
					}
				}
			}
		}

		/* 我的看板 */
		.board-more {
			font-size: 13px;
			color: #666;

			&:hover {
				color: var(--color-main);
			}

			.tf {
				margin-right: 4px;
				font-size: 14px;
			}
		}

		.board-body {
			gap: 14px;
			padding: 4px 20px 20px;

			.board-item {
				gap: 20px;
				box-sizing: border-box;
				width: calc((100% - 42px) / 4);
				height: 100px;
				border-radius: 6px;
				padding: 0 24px;
				background: #EFF6FA;

				&:hover {
					background: var(--color-main);

					.board-label,
					.board-value {
						color: #fff;
					}
				}

				.board-label {
					font-size: 13px;
					color: #868A99;
				}

				.board-value {
					font-size: 22px;
					color: #111;
				}

				&.z-hl {
					background: linear-gradient(135deg, #3D5EFF, #5F7FFF);

					.board-label {
						color: rgba(255,255,255,.85);
					}

					.board-value {
						color: #fff;
					}
				}
			}
		}

		/* 趋势图表 */
		.chart-head {
			.chart-tab {
				span {
					position: relative;
					padding: 0 4px;
					line-height: 50px;
					font-size: 15px;
					color: #666;
					cursor: pointer;

					& + span {
						margin-left: 24px;
					}

					&.z-alive {
						font-weight: bold;
						color: #333;

						&:after {
							content: '';
							position: absolute;
							left: 50%;
							bottom: 0;
							width: 36px;
							height: 3px;
							border-radius: 2px;
							background: var(--color-main);
							transform: translate(-50%, 0);
						}
					}
				}
			}

			.range-group {
				border: 1px solid #E5E6EB;
				border-radius: 4px;
				overflow: hidden;

				a {
					padding: 0 14px;
					line-height: 28px;
					font-size: 13px;
					color: #666;
					transition: all .2s ease;

					& + a {
						border-left: 1px solid #E5E6EB;
					}

					&.z-alive {
						color: #fff;
						background: var(--color-main);
					}
				}
			}
		}

		.card-chart {
			flex-grow: 2;
			display: flex;
			flex-direction: column;

			.chart-body {
				flex-grow: 1;
				display: flex;
				flex-direction: column;
			}
		}

		.chart-body {
			padding: 12px 20px 16px;

			.chart {
				flex-grow: 1;
				min-height: 280px;
			}
		}

		/* 右侧栏 */
		.home-aside {
			display: flex;
			flex-direction: column;
			width: 480px;

			.card-guide {
				position: relative;
				height: 358px;
				background: linear-gradient(180deg, rgba(252,239,239,.8), rgba(255,255,255,.8) 100px);

				&:after {
					content: '';
					position: absolute;
					inset: 0;
					background-image: url('~@/assets/image/home_guide.png')
					background-repeat: no-repeat;
					background-position: right bottom;
					background-size: 60% auto;
					pointer-events: none;
				}
			}

			.aside-config {
				font-size: 16px;
				color: #BBB;
				cursor: pointer;

				&:hover {
					color: var(--color-main);
				}
			}

			.aside-more {
				font-size: 13px;
				color: #999;

				&:hover {
					color: var(--color-main);
				}

				.tf {
					margin-left: 2px;
					font-size: 12px;
				}
			}
		}

		/* 公司信息 */
		.company {
			position: relative;
			box-sizing: border-box;
			height: 142px;
			padding: 26px 22px 0;

			&-share {
				position: absolute;
				right: 16px;
				top: 16px;
				font-size: 15px;
				color: #CCC;
				cursor: pointer;

				&:hover {
					color: var(--color-main);
				}
			}

			&-logo {
				flex-shrink: 0;
				width: 44px;
				height: 44px;
				margin-right: 12px;
				border-radius: 50%;
				overflow: hidden;
				background: linear-gradient(135deg, #3D5EFF, #5F7FFF);
			}

			&-name {
				font-size: 15px;
				font-weight: bold;
				color: #333;
			}

			&-vip {
				flex-shrink: 0;
				border-radius: 3px;
				margin-left: 10px;
				padding: 6px 8px;
				font-size: 12px;
				font-weight: bold;
				color: #B8821C;
				background: linear-gradient(135deg, #FFF3D6, #FFE4A8);
			}

			&-line {
				margin-top: 4px;
				font-size: 13px;
				color: #666;

				p {
					white-space: nowrap;
				}

				.company-role {
					border-radius: 3px;
					margin: 0 16px 0 8px;
					padding: 6px 6px;
					font-size: 12px;
					color: var(--color-main);
					background: #EEF2FF;
				}

				.company-code {
					.tf {
						margin-left: 6px;
						font-size: 13px;
						color: #BBB;
						cursor: pointer;

						&:hover {
							color: var(--color-main);
						}
					}
				}
			}

			&-account {
				margin-top: 32px;
				font-size: 12px;
				color: #666;

				a {
					color: var(--color-main);
				}
			}
		}

		/* 常用功能 */
		.func-body {
			gap: 10px;
			padding: 2px 20px 20px;

			.func-empty {
				width: 100%;
				margin: 8px 0;
				text-align: center;
				font-size: 13px;
				color: #999;
			}

			.func-item {
				box-sizing: border-box;
				width: calc((100% - 30px) / 4);
				height: 36px;
				border: 1px solid #eee;
				font-size: 13px;
				color: #333;
				background: #fff;

				&:hover {
					border-color: var(--color-main);
					color: var(--color-main);
				}
			}
		}

        .notice-body li.article-read .notice-title,
        .guide-body li.article-read p {
            color: #aaa;
        }

		/* 最新公告 */
		.notice-body {
			padding: 4px 20px 16px;

			li {
				padding: 10px 0;
				cursor: pointer;

				&:hover .notice-title {
					color: var(--color-main);
				}
			}

			.notice-tag {
				flex-shrink: 0;
				border-radius: 3px;
				margin-right: 12px;
				padding: 6px 6px;
				font-size: 12px;
				color: #666;
				background: #F5F5F5;
			}

			.notice-title {
				overflow: hidden;
				font-size: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				transition: all .2s ease;
			}

			.notice-new {
				flex-shrink: 0;
				border-radius: 2px;
				margin-left: 8px;
				padding: 1px 4px;
				font-size: 10px;
				font-weight: bold;
				transform: scale(.9);
				color: #fff;
				background: #FF4D4F;
			}

			.notice-time {
				margin-top: 10px;
				font-size: 12px;
				color: #999;
			}
		}

		/* 新手入门 */
		.guide-body {
			padding: 4px 20px 16px;

			li {
				height: 36px;
				font-size: 13px;
				cursor: pointer;

				&:hover {
					color: var(--color-main);
				}

				.tf {
					margin-right: 10px;
					font-size: 15px;
					color: #BBB;
				}

				p {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
		}
	}
</style>
